/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {deactivateMultipleActiveInstruments} from '../api'

export const useMutationDeactivateMultipleActiveInstruments = createReactQueryMutationHook('deactivateMultipleActiveInstruments', deactivateMultipleActiveInstruments)
